import { render, staticRenderFns } from "./ActionsMenuHR.vue?vue&type=template&id=ff6a81a8"
import script from "./ActionsMenuHR.vue?vue&type=script&lang=js"
export * from "./ActionsMenuHR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports